module.exports = __webpack_public_path__ + "static/media/PY.c259ae07.svg";